import React from "react";

import { OverflowTooltip } from "components";
import PaymentTypes from "types/enums/paymentTypes";
import { PaymentMethodValues } from "types/paymentMethod";

import styles from "../../paymentMethods.module.scss";
const paymentTypeColumn = () => ({
	Header: "Payment Type",
	accessor: "paymentType",

	classNameHeader: styles.paymentCellHeader,
	classNameCell: styles.paymentCellColumn,
	Cell({ cell, row }) {
		const original: PaymentMethodValues = row.original;

		const { paymentType } = original;
		const paymentMethod = PaymentTypes.getByValue(paymentType?.value);

		return (
			<>
				{paymentMethod?.displayName && (
					<OverflowTooltip
						onlyOnLaptop
						title={paymentMethod?.displayName}
					>
						{paymentMethod?.displayName}
					</OverflowTooltip>
				)}
			</>
		);
	},
});

export default paymentTypeColumn;
